let lang;
$(document).ready(function () {
  $(function () {
    initLs();
  });
});

function initLs() {
  // const container = document.getElementById('campaignSlider');
  // const leftArrow = document.getElementById('navLeft');
  // const rightArrow = document.getElementById('navRight');
  // const scrollAmount = 320;
  // // Attach click events safely inside JavaScript
  // leftArrow.addEventListener('click', () => {
  //   container.scrollBy({
  //     left: -scrollAmount,
  //     behavior: 'smooth',
  //   });
  // });
  // rightArrow.addEventListener('click', () => {
  //   container.scrollBy({
  //     left: scrollAmount,
  //     behavior: 'smooth',
  //   });
  // });
}
